import { Injectable, Inject } from '@angular/core';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { HttpClient } from '@angular/common/http';
import { InvoiceDeliveryConfiguration } from '../../model/invoice-delivery-configuration';

@Injectable()
export class InvoiceDeliveryConfigurationService extends DataService<InvoiceDeliveryConfiguration> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, InvoiceDeliveryConfiguration, progressBar, 'invoice-delivery-settings');
  }
}
